import { Data } from '../models/data';
import deepmerge from 'deepmerge';

export type ArrayMergeFn = (target: any[], source: any[], options?: any) => any[];

export const combineMerge = (target: any[], source: any[], options?: any): any[] => {
  const destination = target.slice();

  source.forEach((item, index) => {
    if (typeof destination[index] === 'undefined') {
      destination[index] = options.cloneUnlessOtherwiseSpecified(item, options);
    } else if (options.isMergeableObject(item)) {
      destination[index] = deepmerge(target[index], item, options);
    } else if (target.indexOf(item) === -1) {
      destination.push(item);
    }
  });
  return destination;
};

export const concatArrayElements = (target: any[], source: any[], options?: any): any[] => {
  const destination = target.slice();
  source.forEach((item, index) => {
    if (typeof destination[index] === 'undefined') {
      destination[index] = options.cloneUnlessOtherwiseSpecified(item, options);
    } else if (target.indexOf(item) === -1) {
      destination.push(item);
    }
  });
  return destination;
};

export const CombineMergeOpts = Object.freeze({
  none: null,
  combineMerge,
  concatArrayElements,
});

export function deepMerge(data1: Data, data2: Data, mergeFn: ArrayMergeFn = CombineMergeOpts.combineMerge) {
  if (mergeFn === null) {
    return deepmerge(data1, data2);
  } else {
    return deepmerge(data1, data2, { arrayMerge: mergeFn });
  }
}
